"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workflowsCommon_de_de = void 0;
function workflowsCommon_de_de() {
    return {
        "workflows.errors.connections.duplicatesocket": "Doppelte Verbindung an einem Sockel"
    };
}
exports.workflowsCommon_de_de = workflowsCommon_de_de;
